import { Component, inject } from '@angular/core';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
  standalone: false,
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent {
  public configurationService = inject(ConfigurationService);
}
